<template>
<div id="contents">
  <div id="magic" class="page_contents">
    <div class="page_header">
      <h1 class="page_header_title">
        <img src="../assets/img/works/program/title.png" width="234" alt="WORKS">
        <span>制作実績</span>
      </h1><!-- .top_sec_title -->
    </div><!-- .page_header -->

    <worksPageNav/>

    <div id="magic_contents">
      <p class="page_title"><img src="../assets/img/magic/title.png" width="187" alt="MAGIC" /></p>
      <div class="message">
        <p>当社では、マジックのテレビ番組制作を中心に、ステージ制作・運営、提携しているマジシャンのメディア対応窓口業務などをサポートしています。<br />番組出演やディナーショー・講演会・イベント・ワークショップ・マジック監修・道具制作などのご依頼はもちろん、マジックに関することならなんでもお気軽にお問い合わせください。<br />マジシャンのクリエイティビティと、当社が培ってきた映像制作のノウハウ、知見、実績をあわせて化学反応を起こし、新しい企画や商品を生み出します。</p>
      </div>
      <div class="contact_btn_wrap">
        <p class="contact_btn"><router-link v-bind:to="{ name : 'contact', params : { referrer: 'MAGICについて', link: true }}" class="c_link">MAGICに関する<br />お問い合わせはこちら</router-link></p>
      </div><!-- .contact_btn_wrap -->
      <div class="belonging_cast">
        <div id="magic_index_main" v-if="main_cast">
          <transition-group tag="div" id="magic_index_main_box">
            <div v-for="cast in main_cast" :key="cast.post_id" class="magic_card hover">
              <div class="magic_index_image_main">
                <div class="update_icon" v-if="cast.update_icon"><p>UPDATE</p></div>
                <router-link v-bind:to="{name: 'magic_show', params: {id: cast.post_id}}" ><img :src="cast.single_main_image" width="100%" alt="MAGIC" /></router-link>
              </div>
              <div class="magic_card_inner">
                <h3>
                  <router-link v-bind:to="{name: 'magic_show', params: {id: cast.post_id}}" >
                    <span>{{ cast.name }}</span>
                    <span class="en">{{ cast.english_name }}</span>
                  </router-link>
                </h3>
              </div><!-- .magic_card_inner -->
            </div><!-- .magic_card -->
          </transition-group><!-- #magic_index_main_box -->
        </div><!-- .magic_index_main -->
        <div id="magic_index_sub" v-if="sub_cast">
          <transition-group tag="div" id="magic_index_sub_box">
            <div v-for="cast in sub_cast" :key="cast.post_id" class="magic_card hover">
              <div class="magic_index_image_main">
                <div class="update_icon" v-if="cast.update_icon"><p>UPDATE</p></div>
                <router-link v-bind:to="{name: 'magic_show', params: {id: cast.post_id}}" ><img :src="cast.single_main_image" width="100%" alt="MAGIC" /></router-link>
              </div>
              <div class="magic_card_inner">
                <h3>
                  <router-link v-bind:to="{name: 'magic_show', params: {id: cast.post_id}}" >
                    <span>{{ cast.name }}</span>
                    <span class="en">{{ cast.english_name }}</span>
                  </router-link>
                </h3>
              </div><!-- .magic_card_inner -->
            </div><!-- .magic_card -->
          </transition-group><!-- #magic_index_main_box -->
        </div><!-- #magic_index_sub -->
      </div>
      <div class="training_programs">
        <h2>研修事業</h2>
        <p class="banner"><a class="hover" href="https://www.maric.jp/school/" target="_blank" rel="noopener"><img src="../assets/img/magic/banner.jpg" alt="生徒を振り向かせる授業力。マジシャンがあげます。" width="280" /></a></p>
      </div>
    </div><!-- #magic_contents -->

  </div><!-- #magic -->

</div><!-- #contents -->
</template>

<script>
import worksPageNav from './shared/worksPageNav.vue'
import tapcastContact from './shared/tapcastContact.vue'
export default {
  name: 'players_index',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/tapcast/index.php',
      api_category_url: this.$parent.api_base_url+'/api/tapcast/fetch_category.php',
      category_box: false,
      loading: false,
      cast: null,
      biz_collab_cast: [],
      categories: null,
      select_category: 0,
      select_category_name: 'ジャンル別に見る',
      error: null
    }
  },
  computed: {
    main_cast: function(){
      if(this.cast){
        return this.cast.slice(0, 1)
      }
    },
    sub_cast: function(){
      if(this.cast){
        return this.cast.slice(1)
      }
    }
  },
  components: {
    worksPageNav,
    tapcastContact
  },
  methods: {
    fetch_cast_list(){
      this.$axios
        .get(this.api_url)
        .then(response => {
          this.cast = response.data.item
          for (let i = 0; i < this.cast.length; i++) {
            if (["biz_collab"].includes(this.cast[i].affiliation)) {
              this.biz_collab_cast = this.biz_collab_cast.concat(this.cast[i])
              this.cast.splice(i--, 1);
            }
          }
          if(this.biz_collab_cast == false){
            this.biz_collab_cast = null
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    show_category_box(){
      if(!this.category_box){
        this.category_box = true
      }
    },
    slect_category(event){
      const term_id = event.target.getAttribute('data')
      const name = event.target.getAttribute('name')
      this.select_category = term_id
      this.select_category_name = name
      this.fetch_player_list()
      this.category_box = false
      event.preventDefault()
    },
    fetch_category_list(){
      this.$axios
        .get(this.api_category_url)
        .then(response => {
          this.categories = response.data.categories
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    }
  },
  mounted () {
    this.fetch_category_list()
    this.fetch_cast_list()
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  },
  updated (){
  }
}
</script>

<style scoped lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/magic_index.vue